module.exports = __webpack_public_path__ + "img/arrow-right.9b5d3608.svg";